export default "__VITE_ASSET__DrVUIso1__"